const dev = {
  AWS_PROFILE: "foreks-sae",
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_4CVWoMhTX",
    APP_CLIENT_ID: "3s7ulp04ei4ceognqu3mr9c1a2",
    IDENTITY_POOL_ID: "us-west-2:780e6d38-d390-4fe3-a136-8e03ca9f9460",
  },
  settingsGateway: {
    REGION: "us-west-2",
    URL: "https://ea5fqbzhjd.execute-api.us-west-2.amazonaws.com/dev/",
  },
  resultsGateway: {
    REGION: "us-west-2",
    URL: "https://wp8h5cog90.execute-api.us-west-2.amazonaws.com/dev/",
  },
  comprehendEngineGateway: {
    REGION: "us-west-2",
    URL: "https://m9maj6c1nf.execute-api.us-west-2.amazonaws.com/dev",
  },
  bertEngineGateway: {
    REGION: "us-west-2",
    URL: "https://st81pkbonj.execute-api.us-west-2.amazonaws.com/dev/",

  },
};

const prod = {
  AWS_PROFILE: "foreks-sae",
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_PIrq5yGsw",
    APP_CLIENT_ID: "2fn67tgo1ml5obm3sh1h3jchve",
    IDENTITY_POOL_ID: "us-west-2:e3f44656-6d80-4077-a56a-4e8e1dfd4287",
  },


  settingsGateway: {
    REGION: "us-west-2",
    URL: "https://wppjifwnnd.execute-api.us-west-2.amazonaws.com/prod/",
  },
  resultsGateway: {
    REGION: "us-west-2",
    URL: "https://4w1theb04g.execute-api.us-west-2.amazonaws.com/prod/",
  },
  comprehendEngineGateway: {
    REGION: "us-west-2",
    URL: "https://vk669j9k88.execute-api.us-west-2.amazonaws.com/prod/",
  },
  bertEngineGateway: {
    REGION: "us-west-2",
    URL: "https://ul4o8gljde.execute-api.us-west-2.amazonaws.com/prod/",
  },
};
const config = process.env.REACT_APP_STAGE === "prod" ? prod : dev;

export default {
  //add common config values here
  //MAX_TIMEOUT: 1000 for example
  ...config,
};
